<template>
    <vs-popup :active.sync="showPopup" :title="title">
        <div class="vx-row">
            <div class="vx-col w-full" style="text-align: center">
            <vs-select v-model="area" class="w-full">
                <vs-select-item
                        v-for="(item) in options"
                        :key="item"
                        :value="item"
                        :text="item"
                />
            </vs-select>
            <vs-button @click="openHatch" class="padding-top">Luik open in {{ this.area}}</vs-button>
            </div>
        </div>
    </vs-popup>
</template>

<script>
    export default {
        data() {
            return {
                showPopup: false,
                area: "Spijkenisse",
                options: [
                    'Spijkenisse',
                    'Schiedam'
                ]
            };
        },

        computed: {
            title() {
                return 'Luik open in ' + this.area + '?';
            }
        },

        methods: {
            openHatch() {
                let data = new FormData();
                data.append('area', this.area);
                this.$http
                    .post("https://staffapi.hebtrek.nl/v1/hatch/open/manual", data, {
                        headers: {
                            Authorization:
                                "Bearer " + JSON.parse(localStorage.getItem("stafftoken")),
                            "Content-Type": "multipart/form-data",
                        },
                    })
                    .then(() => {
                        this.$vs.notify({
                            title: "Success",
                            text: "Luik in " + this.area + " gaat nu open",
                            color: "success",
                        });
                        this.showPopup = false;
                    })
                    .catch((error) => {
                        this.$util.logError(error, this.$vs);
                    });
            }
        },

        mounted() {
            this.$events.listen('open-manual-hatch-popup', () => {
                this.showPopup = true;
            });
        }
    };
</script>
<style>
    .padding-top {
        padding-top: 25px;
    }
</style>